// Chakra imports
import {Box, Button, Flex, Image, Switch, Text, useColorModeValue,} from "@chakra-ui/react";
import React from "react";
import {deleteRoster} from "./services";

const RosterCard = ({
                              image,
                              roster,
                              avatars,
                              description,
                              fetchRosterList,
                              setIsRosterPage,
                              handleSetActiveRoster
                          }) => {
    // Chakra color mode
    const textColor = useColorModeValue("gray.700", "white");


    const handleRosterPage = (activeRoster) => {
        console.log('active::', activeRoster)
        handleSetActiveRoster(activeRoster);
        setIsRosterPage(false);
    }

    const deleteRosterDetail = async (roster) => {
        let request = {
            id: roster.id
        }
        try {
            const response = await deleteRoster(request);
            if (response.status === 200) {
                fetchRosterList();
            }
        } catch (e) {
            console.error(e);
        }

    }

    return (
        <Flex direction='column'>
            <Box mb='20px' position='relative' borderRadius='15px'>
                <Image src={image} borderRadius='15px'/>
                <Box
                    w='100%'
                    h='100%'
                    position='absolute'
                    top='0'
                    borderRadius='15px'
                    bg='linear-gradient(360deg, rgba(49, 56, 96, 0.16) 0%, rgba(21, 25, 40, 0.88) 100%)'></Box>
            </Box>
            <Flex direction='column' p='4' bg='white' borderRadius='md' boxShadow='md' maxW='400px' w='full'
                  position='relative'>
                <Text fontSize='lg' color='gray.600' fontWeight='bold' mb='4'>
                    {roster?.name || "Unnamed Roster"}
                </Text>
                <Text fontSize='xl' color={textColor} fontWeight='semibold' mb='4'>
                    Total Bells: {roster?.bellNumber || 0}
                </Text>

                <Flex alignItems='center' justifyContent='space-between' mb='4'>
                    <Flex direction='column'>
                        <Text fontSize='md' color='gray.500' fontWeight='medium'>
                            Start Date:
                        </Text>
                        <Text fontSize='sm' color='gray.600' fontWeight='normal'>
                            {roster?.startDate || "N/A"}
                        </Text>
                    </Flex>
                    <Flex direction='column'>
                        <Text fontSize='md' color='gray.500' fontWeight='medium'>
                            End Date:
                        </Text>
                        <Text fontSize='sm' color='gray.600' fontWeight='normal'>
                            {roster?.endDate || "N/A"}
                        </Text>
                    </Flex>
                </Flex>

                <Flex alignItems='center' justifyContent='space-between' mb='4'>
                    <Flex alignItems='center'>
                        <Text fontSize='md' color='gray.500' fontWeight='medium' mr='2'>
                            Is Enabled:
                        </Text>
                        <Switch
                            size='md'
                            colorScheme='teal'
                            isChecked={roster?.isEnabled}
                            disabled={true}
                            // onChange={() => toggleRosterEnabled(roster)}
                        />
                    </Flex>
                </Flex>

                <Flex justifyContent='space-between' alignItems='center'>
                    <Button
                        variant='solid'
                        colorScheme='teal'
                        minW='120px'
                        h='40px'
                        fontSize='sm'
                        px='1.5rem'
                        onClick={() => handleRosterPage(roster)}
                    >
                        View Bells
                    </Button>
                    {/*<AvatarGroup size='sm' max={3}>*/}
                    {/*    {avatars.map((el, idx) => (*/}
                    {/*        <Avatar src={el} key={idx} />*/}
                    {/*    ))}*/}
                    {/*</AvatarGroup>*/}
                </Flex>

                {/* Circular Delete Button */}
                {/*<Button*/}
                {/*    position='absolute'*/}
                {/*    bottom='4'*/}
                {/*    right='4'*/}
                {/*    colorScheme='red'*/}
                {/*    borderRadius='full'*/}
                {/*    boxShadow='sm'*/}
                {/*    size='lg'*/}
                {/*    onClick={() => deleteRosterDetail(roster)}*/}
                {/*    aria-label='Delete Roster'*/}
                {/*>*/}
                {/*    🗑️*/}
                {/*</Button>*/}
            </Flex>

        </Flex>
    );
};

export default RosterCard;
